import React, { JSX } from 'react';

import { Col, ITProps, Row, Rows, Text, TKey } from '~/src/dash/publicaUI';

interface IProps {
  tKey: TKey;
  tProps?: ITProps;
  value: string;
}

export const ColKeyValuePair = ({ tKey, tProps, value }: IProps): JSX.Element | null => {
  if (!value || value === 'Unknown') return null;
  return (
    <Col style={{ flex: '1 1 calc(50% - 12px)', minWidth: '200px', maxWidth: 'calc(50% - 12px)' }}>
      <Rows smallVerticalPadding>
        <Row noPadding>
          <Text extraSmall bold muted tKey={tKey} tProps={tProps} />
        </Row>
        <Row noPadding>
          <Text
            small
            style={{
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              maxWidth: '100%',
            }}
          >
            {value}
          </Text>
        </Row>
      </Rows>
    </Col>
  );
};
